import { useStaticQuery, graphql } from 'gatsby'

export function useDataDevelopmentByEn() {
    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageAbout(title: { eq: "Title small" }, locale: { eq: "en" }) {
                value
            }

            titleOne: datoCmsRenshinPageAbout(title: { eq: "Block 1: Title" }, locale: { eq: "en" }) {
                value
            }

            textOne: datoCmsRenshinPageAbout(title: { eq: "Block 1: Text" }, locale: { eq: "en" }) {
                value
            }

            yearOneText: datoCmsRenshinPageAbout(title: { eq: "Block 1: Text left" }, locale: { eq: "en" }) {
                value
            }

            yearOne: datoCmsRenshinPageAbout(title: { eq: "Block 1: Year" }, locale: { eq: "en" }) {
                value
            }

            titleTwo: datoCmsRenshinPageAbout(title: { eq: "Block 2: Title" }, locale: { eq: "en" }) {
                value
            }

            textTwo: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text" }, locale: { eq: "en" }) {
                value
            }

            textNumberLeft: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 1" }, locale: { eq: "en" }) {
                value
            }

            textNumber: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 2" }, locale: { eq: "en" }) {
                value
            }

            textNumberRight: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 3" }, locale: { eq: "en" }) {
                value
            }

            textNumberBottom: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 4" }, locale: { eq: "en" }) {
                value
            }
        }
    `)

    return data
}
